"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.constants = void 0;
var TAG_ADDON = ['addon', 'add-on', 'add_on'];
var TAG_COLLECTION = 'collection';
var TAG_DISCOUNT = 'discount';
var TAG_GIFT = 'gift';
var TAG_HARDWARE = 'hardware';
var TAG_HOME_PHONE = 'homephone';
var TAG_INSTALLATION = 'installation';
var TAG_INTERNET = 'internet';
var TAG_LWC = 'lwc';
var TAG_MOBILITY_ACCESSORY = 'MOBILITY_ACCESSORY';
var TAG_MOBILITY_ADDON = ['MOBILITY_ADDON', 'MOBILITY_ADD-ON', 'MOBILITY_ADD_ON'];
var TAG_MOBILITY_PHONE = 'MOBILITY_PHONE';
var TAG_MOBILITY_PLAN = 'MOBILITY_PLAN';
var TAG_MOBILITY_SIM = 'MOBILITY_SIM';
var TAG_MOBILITY_TABLET = 'MOBILITY_TABLET';
var TAG_MOBILITY_WARRANTY = 'MOBILITY_WARRANTY';
var TAG_ONLINE_SECURITY = 'online-security';
var TAG_SECURITY = 'security';
var TAG_SERVICE = 'service';
var TAG_SERVICE_PLAN = 'service-plan';
var TAG_SMARTWATCH = 'smartwatch';
var TAG_SMARTWEAR = 'smartwear';
var TAG_SMARTWEAR_DEVICE = 'smartwear-device';
var TAG_STREAMING = 'streaming';
var TAG_THEMEPACK = 'themepack';
var TAG_TV = 'tv';
var TAG_TVX = 'tvx';
var TAG_VAS = 'vas';
var CATEGORY_HEALTH = 'health';
var CATEGORY_HOME_PHONE = 'homephone';
var CATEGORY_INSTALLATION = 'installation';
var CATEGORY_INTERNET = 'internet';
var CATEGORY_MOBILITY = 'mobility';
var CATEGORY_ONLINE_SECURITY = 'online_security';
var CATEGORY_SMARTHOME_SECURITY = 'smarthome_security';
var CATEGORY_SMARTWEAR = 'smartwear';
var CATEGORY_TV_OPTIK = 'tv_optik';
var CATEGORY_TV_PIK = 'tv_pik';
var CATEGORY_TV_STREAMING = 'tv_streaming';
var SUBCATEGORY_CORE_PRODUCT = 'core_product';
var SUBCATEGORY_NOT_CORE_PRODUCT = 'not_core_product';
var TYPE_ACCESSORY = 'accessory';
var TYPE_ADDON = 'add-on';
var TYPE_DEVICE = 'device';
var TYPE_DISCOUNT = 'discount';
var TYPE_GIFT = 'gift';
var TYPE_INSTALLATION_METHOD = 'installation_method';
var TYPE_PHONE = 'phone';
var TYPE_SERVICE = 'service';
var TYPE_SIM_CARD = 'sim_card';
var TYPE_SMARTWATCH = 'smartwatch';
var TYPE_STREAMING = 'streaming';
var TYPE_TABLET = 'tablet';
var TYPE_THEMEPACK = 'theme_pack';
var TYPE_WARRANTY = 'warranty';
var NO_VALUE_FOUND = 'no_value_found';
var values = [{
  tags: [TAG_MOBILITY_PLAN],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_MOBILITY_ACCESSORY],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_ACCESSORY]
}, {
  tags: [TAG_MOBILITY_ADDON],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_ADDON]
}, {
  tags: [TAG_MOBILITY_TABLET],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_TABLET]
}, {
  tags: [TAG_MOBILITY_PHONE],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_PHONE]
}, {
  tags: [TAG_MOBILITY_SIM],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_SIM_CARD]
}, {
  tags: [TAG_MOBILITY_WARRANTY],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_WARRANTY]
}, {
  tags: [TAG_SMARTWATCH],
  exceptions: [],
  values: [CATEGORY_MOBILITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_SMARTWATCH]
}, {
  tags: [TAG_INTERNET, TAG_SERVICE],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_INTERNET, TAG_SERVICE_PLAN],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_INTERNET, TAG_ADDON],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_ADDON]
}, {
  tags: [TAG_INTERNET, TAG_DISCOUNT],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_DISCOUNT]
}, {
  tags: [TAG_INTERNET, TAG_HARDWARE],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_DEVICE]
}, {
  tags: [TAG_INTERNET, TAG_GIFT],
  exceptions: [],
  values: [CATEGORY_INTERNET, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_GIFT]
}, {
  tags: [TAG_TV, TAG_COLLECTION],
  exceptions: [],
  values: [CATEGORY_TV_OPTIK, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_TV, TAG_THEMEPACK],
  exceptions: [],
  values: [CATEGORY_TV_OPTIK, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_THEMEPACK]
}, {
  tags: [TAG_TV, TAG_GIFT],
  exceptions: [],
  values: [CATEGORY_TV_OPTIK, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_GIFT]
}, {
  tags: [TAG_TV, TAG_ADDON],
  exceptions: [],
  values: [CATEGORY_TV_OPTIK, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_ADDON]
}, {
  tags: [TAG_TV, TAG_STREAMING],
  exceptions: [],
  values: [CATEGORY_TV_STREAMING, SUBCATEGORY_CORE_PRODUCT, TYPE_STREAMING]
}, {
  tags: [TAG_TVX, TAG_COLLECTION],
  exceptions: [],
  values: [CATEGORY_TV_PIK, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_LWC, TAG_SERVICE],
  exceptions: [],
  values: [CATEGORY_HEALTH, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_LWC, TAG_HARDWARE],
  exceptions: [],
  values: [CATEGORY_HEALTH, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_DEVICE]
}, {
  tags: [TAG_HOME_PHONE, TAG_SERVICE],
  exceptions: [],
  values: [CATEGORY_HOME_PHONE, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_SECURITY, TAG_SERVICE],
  exceptions: [TAG_SMARTWEAR],
  values: [CATEGORY_SMARTHOME_SECURITY, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_SECURITY, TAG_HARDWARE],
  exceptions: [],
  values: [CATEGORY_SMARTHOME_SECURITY, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_DEVICE]
}, {
  tags: [TAG_ONLINE_SECURITY, TAG_VAS],
  exceptions: [],
  values: [CATEGORY_ONLINE_SECURITY, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_SMARTWEAR, TAG_SERVICE],
  exceptions: [],
  values: [CATEGORY_SMARTWEAR, SUBCATEGORY_CORE_PRODUCT, TYPE_SERVICE]
}, {
  tags: [TAG_SMARTWEAR_DEVICE],
  exceptions: [],
  values: [CATEGORY_SMARTWEAR, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_DEVICE]
}, {
  tags: [TAG_INSTALLATION],
  exceptions: [],
  values: [CATEGORY_INSTALLATION, SUBCATEGORY_NOT_CORE_PRODUCT, TYPE_INSTALLATION_METHOD]
}];
var constants = exports.constants = {
  TAG_GIFT: TAG_GIFT,
  SUBCATEGORY_CORE_PRODUCT: SUBCATEGORY_CORE_PRODUCT,
  SUBCATEGORY_NOT_CORE_PRODUCT: SUBCATEGORY_NOT_CORE_PRODUCT,
  TYPE_GIFT: TYPE_GIFT,
  NO_VALUE_FOUND: NO_VALUE_FOUND
};
var _default = exports["default"] = values;